import { render, staticRenderFns } from "./ControlAnalysis.vue?vue&type=template&id=836c30bc"
import script from "./ControlAnalysis.vue?vue&type=script&lang=js"
export * from "./ControlAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ControlAnalysis.vue?vue&type=style&index=0&id=836c30bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports